import { useNavigate  } from 'react-router-dom';

export function goTo(url?: string) {
  const navigate = useNavigate();
  return (e?) => {
    if (e) e.preventDefault();
    if (url) navigate(url);
  }
}
